import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import ValueGrid from './ValueGrid'

const TitleValueGrid = ({
  title,
  data,
}) => {

  return (
    <>
      <Grid container spacing={ 4 }>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>
            { title }
          </Typography>
        </Grid>
      </Grid>
      <ValueGrid
        spacing={ 1 }
        titleProps={{
          variant: 'body1',
          color: 'textSecondary'
        }}
        data={ data }
      />
    </>
  )
}

export default TitleValueGrid